module.exports = __webpack_public_path__ + "static/img/eat-type-item-02.ac6056bc.png";